window.addEventListener('DOMContentLoaded', () => {
  const cookies = document.cookie;
  const cookiesArray = cookies.split('; ');
  let urlValue = '';
  const historyCounts = 30;
  let uArray;
  for (const c of cookiesArray) {
    const cArray = c.split('='); // 名前とvalueの分解
    if (cArray[0] === 'history_record') {
      // クッキーを入れる際にエンコードして日本語を入れているため整形するためにデコード
      const decodeData = decodeURIComponent(cArray[1]);
      uArray = decodeData.split(' : ');
      if (uArray.length >= historyCounts) {
        uArray.pop();
        urlValue = uArray.join(' : ');
      } else {
        urlValue = decodeData;
      }
      break;
    }
  }
  // #search_cookieと言うinput hidden要素に求人一覧の日本語タイトルを格納している
  // そのデータをsArrayに格納
  const search_cookie = document.getElementById('search_cookie');
  const sArray = search_cookie.value.split(', ');
  let cookieValue = '';
  for (const s of sArray) {
    cookieValue += s;
  }
  if (urlValue === '' || uArray[0] !== `・検索条件：${cookieValue}`) {
    const name = 'history_record'; // クッキーの名前
    const value = `・検索条件：${cookieValue} : ${urlValue}`;
    // クッキーを日本語でそのまま入れるとNext.jsでバグの原因になったためエンコードする
    const encodeValue = encodeURIComponent(value);
    const period = 1; // 有効期限日数（有効期限がないと、ブラウザを閉じた時点で cookieは無効）
    const nowtime = new Date().getTime();
    const clearTime = new Date(nowtime + 60 * 60 * 24 * 1000 * period);
    const expires = clearTime.toUTCString(); // クッキーの発行（書き込み）
    document.cookie = `${name}=${encodeValue};path=/; expires=${expires}`;
  }
});
